<template>
<div class="row align-center">
  <div class="small-12 medium-11 large-12 columns sucesso_historia"
      :class="{'lesspaddingbottom': items.length == 0}">
    <div class="historia_casos">
      <template
        :key="`${index}${testemunho?.Identificacao}`"
        v-for="(resposta, index) in testemunho?.Questionario">
        <HistoriaCasos
          :pergunta="perguntas[index]"
          :resposta="resposta"/>
      </template>
    </div>
  </div>
</div>
</template>

<script>
import { ref } from "vue";
import HistoriaCasos from "@/components/HistoriaCasos.vue";
import { i18n } from "@/main.js";

export default {
  name:"Questionario",
  props:["testemunho","items"],
  components:{
    HistoriaCasos
  },
  setup () {
    const { t } = i18n.global; 
    const perguntas = ref([ 
      t('perguntas.1'), t('perguntas.2'), 
      t('perguntas.3'), t('perguntas.4') 
    ]);

    return {
      perguntas
    }
  }
}
</script>

<style scoped>
.historia_casos {
  padding-top: 80px;
}

.sucesso_historia {
  padding-left: 93px;
  padding-right: 93px;
  margin-bottom: 60px;
}

.sucesso_historia.lesspaddingbottom{
  margin-bottom: 20px;
}

@media only screen and (max-width: 1439px) {
  .sucesso_historia {
    padding-left: 25px !important;
    padding-right: 0px !important;
  }

  .align-center {
    margin-left: 0px;
    margin-right: 0px;
  }

  .historia_casos {
    padding-top: 60px;
  }


  .sucesso_historia {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

}

@media (min-width: 768px) and (max-width: 1024px) {
  .sucesso_historia {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 30px;
  }

  .historia_casos {
    padding-top: 50px;
  }
}


@media (max-width: 767px) {
  .sucesso_historia {
    padding-left: 0 !important;
    margin-bottom: 30px !important;
  }

  .historia_casos {
    padding-top: 30px;
  }

  .sucesso_historia {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

</style>